import { render, staticRenderFns } from "./OfferDetails.html?vue&type=template&id=5948b057&scoped=true&"
import script from "./OfferDetails.js?vue&type=script&lang=js&"
export * from "./OfferDetails.js?vue&type=script&lang=js&"
import style0 from "./OfferDetails.scss?vue&type=style&index=0&id=5948b057&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5948b057",
  null
  
)

export default component.exports